export enum CheckSize {
    big = 'big',
    small = 'small',
}

export interface CheckProps {
    readonly size: CheckSize;
}
